export default __webpack_public_path__ + "static/media/Who we serve 2.f5748df6.jpeg";